const isTouchDevice = (): boolean =>
  'ontouchstart' in window || 'msMaxTouchPoints' in window.navigator;

export default isTouchDevice;
